import { colors } from '@/styles/theme/foundations/colors';
import { useCookie } from '@/util/use-cookie';
import { WarningTwoIcon } from '@chakra-ui/icons';
import { Center, Text, useColorMode, VStack } from '@chakra-ui/react';
import { PropsWithChildren, useEffect, useMemo, useState } from 'react';
import { CookieManager } from '../../../Auth/utils/cookie-manager';
import { CaCookiesContext } from './ca-cookies-context';

export const CaCookiesProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [isHydrated, setIsHydrated] = useState<boolean>(false);

  const [token] = useCookie(CookieManager.getCaAuthTokenName());
  const [apiUrl] = useCookie(CookieManager.getCaApiUrlName());

  const { colorMode } = useColorMode();

  const memoizedValue = useMemo(() => ({ token, apiUrl }), [token, apiUrl]);

  const isMissingCredentials = !token || !apiUrl;

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  useEffect(() => {
    if (isMissingCredentials) {
      // redirect to CA my orgs page in 2.5 seconds
      setTimeout(() => {
        window.location.replace(
          `${process.env.NEXT_PUBLIC_FRONTEND_DOMAIN_V1 as string}/my-organizations?redirect=${window.location.href}`,
        );
      }, 2500);
    }
  }, [isMissingCredentials]);

  // Render nothing (for SSR hydration issue) -- until useEffect is hit
  if (!isHydrated) {
    return null;
  }

  return (
    <CaCookiesContext.Provider value={memoizedValue}>
      {isMissingCredentials ? (
        <Center minH="100vh" as={VStack} bg={colors.background.global[colorMode]}>
          <WarningTwoIcon />
          <Text>Unable to verify credentials. Redirecting...</Text>
        </Center>
      ) : (
        children
      )}
    </CaCookiesContext.Provider>
  );
};
